export const CREATE_PLAYLIST = "CREATE_PLAYLIST";
export const ADD_SONG_TO_PLAYLIST = "ADD_SONG_TO_PLAYLIST";
export const CONFORMATION = "CONFORMATION";
